import { MapPin, Plus, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../shared/components/Button'

interface LiveNewPlacePromptProps {
  onAddPlace: () => void
  onDismiss: () => void
}

export function LiveNewPlacePrompt({ onAddPlace, onDismiss }: LiveNewPlacePromptProps) {
  const { t } = useTranslation()

  return (
    <div
      className="mb-5 flex items-start gap-3 rounded-st-lg border border-st-warning/40 bg-st-warning/10 p-4"
      role="status"
      aria-live="polite"
    >
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-st-md bg-st-warning/20 text-st-warning">
        <MapPin className="h-5 w-5" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="font-medium text-st-text">{t('live.new_place_title')}</p>
        <p className="mt-0.5 text-sm text-st-muted">{t('live.new_place_body')}</p>
        <div className="mt-3 flex flex-wrap gap-2">
          <Button className="min-h-9 px-3" onClick={onAddPlace}>
            <Plus className="h-4 w-4" /> {t('live.add_to_trip')}
          </Button>
          <button
            type="button"
            onClick={onDismiss}
            className="inline-flex min-h-9 items-center gap-1 rounded-st-md px-3 text-sm text-st-muted hover:bg-st-surface-2 hover:text-st-text"
          >
            <X className="h-4 w-4" /> {t('live.dismiss')}
          </button>
        </div>
      </div>
    </div>
  )
}
